export const LOGIN_REQUEST = 'user::LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'user::LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'user::LOGIN_FAILURE';
export const LOGIN_ERROR_RESET = 'user::LOGIN_ERROR_RESET';

export const LOGIN_SILENTLY = 'user::LOGIN_SILENTLY';
export const LOGIN_SILENTLY_FAILURE = 'user::LOGIN_SILENTLY_FAILURE';
export const LOGIN_SILENTLY_SUCCESS = 'user::LOGIN_SILENTLY_SUCCESS';

export const SET_REFRESH_TOKEN_ERROR = 'user::SET_REFRESH_TOKEN_ERROR';

export const LOGIN_WITH_CREDENTIALS = 'user::LOGIN_WITH_CREDENTIALS';
export const LOGIN_WITH_SESSION_TOKEN = 'user::LOGIN_WITH_SESSION_TOKEN';
export const LOGOUT = 'user::LOGOUT';
export const LOGOUT_SUCCESS = 'user::LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'user::LOGOUT_FAILURE';

export const CHANGE_PROFILE = 'user::CHANGE_PROFILE';
export const SET_LANGUAGE = 'user::SET_LANGUAGE';

export const GET_ENTITLEMENTS = 'user::GET_ENTITLEMENTS';
export const GET_ENTITLEMENTS_REQUEST = 'user::GET_ENTITLEMENTS_REQUEST';
export const GET_ENTITLEMENTS_SUCCESS = 'user::GET_ENTITLEMENTS_SUCCESS';
export const GET_ENTITLEMENTS_FAILURE = 'user::GET_ENTITLEMENTS_FAILURE';

export const UPDATE_RATINGS_THRESHOLDS = 'user::UPDATE_RATINGS_THRESHOLDS';
export const UPDATE_RATINGS_THRESHOLDS_REQUEST =
    'user::UPDATE_RATINGS_THRESHOLDS_REQUEST';
export const UPDATE_RATINGS_THRESHOLDS_SUCCESS =
    'user::UPDATE_RATINGS_THRESHOLDS_SUCCESS';
export const UPDATE_RATINGS_THRESHOLDS_FAILURE =
    'user::UPDATE_RATINGS_THRESHOLDS_FAILURE';
export const UPDATE_RATINGS_THRESHOLDS_CLEAN_REQUEST =
    'user::UPDATE_RATINGS_THRESHOLDS_CLEAN_REQUEST';

export const SET_MODAL_VISIBLE = 'user::SET_MODAL_VISIBLE';

export const GET_PINS_STATUS = 'user::GET_PINS_STATUS';
export const GET_PINS_STATUS_REQUEST = 'user::GET_PINS_STATUS_REQUEST';
export const GET_PINS_STATUS_SUCCESS = 'user::GET_PINS_STATUS_SUCCESS';
export const GET_PINS_STATUS_FAILURE = 'user::GET_PINS_STATUS_FAILURE';

export const GET_FAVOURITES_CHANNELS_LIST =
    'user::GET_FAVOURITES_CHANNELS_LIST';
export const GET_FAVOURITES_CHANNELS_LIST_REQUEST =
    'user::GET_FAVOURITES_CHANNELS_LIST_REQUEST';
export const GET_FAVOURITES_CHANNELS_LIST_SUCCESS =
    'user::GET_FAVOURITES_CHANNELS_LIST_SUCCESS';
export const GET_FAVOURITES_CHANNELS_LIST_FAILURE =
    'user::GET_FAVOURITES_CHANNELS_LIST_FAILURE';

export const UPDATE_FAVOURITES_CHANNELS_LIST =
    'user::UPDATE_FAVOURITES_CHANNELS_LIST';
export const UPDATE_FAVOURITES_CHANNELS_LIST_REQUEST =
    'user::UPDATE_FAVOURITES_CHANNELS_LIST_REQUEST';
export const UPDATE_FAVOURITES_CHANNELS_LIST_SUCCESS =
    'user::UPDATE_FAVOURITES_CHANNELS_LIST_SUCCESS';
export const UPDATE_FAVOURITES_CHANNELS_LIST_FAILURE =
    'user::UPDATE_FAVOURITES_CHANNELS_LIST_FAILURE';

export const CREATE_FAVOURITES_CHANNELS_LIST =
    'user::CREATE_FAVOURITES_CHANNELS_LIST';

export const DELETE_FAVOURITES_CHANNELS_LIST =
    'user::DELETE_FAVOURITES_CHANNELS_LIST';
export const DELETE_FAVOURITES_CHANNELS_LIST_REQUEST =
    'user::DELETE_FAVOURITES_CHANNELS_LIST_REQUEST';
export const DELETE_FAVOURITES_CHANNELS_LIST_SUCCESS =
    'user::DELETE_FAVOURITES_CHANNELS_LIST_SUCCESS';
export const DELETE_FAVOURITES_CHANNELS_LIST_FAILURE =
    'user::DELETE_FAVOURITES_CHANNELS_LIST_FAILURE';

export const GET_PROFILES_LIST = 'user::GET_PROFILES_LIST';
export const GET_PROFILES_LIST_REQUEST = 'user::GET_PROFILES_LIST_REQUEST';
export const GET_PROFILES_LIST_SUCCESS = 'user::GET_PROFILES_LIST_SUCCESS';
export const GET_PROFILES_LIST_FAILURE =
    'user::UPDATE_GET_PROFILES_LIST_FAILURE';

export const GET_PROFILE = 'user::GET_PROFILE';
export const GET_PROFILE_REQUEST = 'user::GET_PROFILE_REQUEST';
export const GET_PROFILE_SUCCESS = 'user::GET_PROFILE_SUCCESS';
export const GET_PROFILE_FAILURE = 'user::UPDATE_GET_PROFILE_FAILURE';

export const CHANGE_USER_PROFILE = 'user::CHANGE_USER_PROFILE';
export const CHANGE_USER_PROFILE_REQUEST = 'user::CHANGE_USER_PROFILE_REQUEST';
export const CHANGE_USER_PROFILE_SUCCESS = 'user::CHANGE_USER_PROFILE_SUCCESS';
export const CHANGE_USER_PROFILE_FAILURE =
    'user::UPDATE_CHANGE_USER_PROFILE_FAILURE';

export const ADD_PROFILE = 'user::ADD_PROFILE';
export const ADD_PROFILE_REQUEST = 'user::ADD_PROFILE_REQUEST';
export const ADD_PROFILE_SUCCESS = 'user::ADD_PROFILE_SUCCESS';
export const ADD_PROFILE_FAILURE = 'user::ADD_PROFILE_FAILURE';

export const EDIT_PROFILE = 'user::EDIT_PROFILE';
export const EDIT_PROFILE_REQUEST = 'user::EDIT_PROFILE_REQUEST';
export const EDIT_PROFILE_SUCCESS = 'user::EDIT_PROFILE_SUCCESS';
export const EDIT_PROFILE_FAILURE = 'user::EDIT_PROFILE_FAILURE';
export const EDIT_PROFILE_REQUEST_RESET = 'user::EDIT_PROFILE_REQUEST_RESET';

export const DELETE_PROFILE = 'user::DELETE_PROFILE';
export const DELETE_PROFILE_REQUEST = 'user::DELETE_PROFILE_REQUEST';
export const DELETE_PROFILE_SUCCESS = 'user::DELETE_PROFILE_SUCCESS';
export const DELETE_PROFILE_FAILURE = 'user::DELETE_PROFILE_FAILURE';
export const DELETE_PROFILE_REQUEST_RESET =
    'user::DELETE_PROFILE_REQUEST_RESET';

export const SELECT_USER_PROFILE_RATING = 'user::SELECT_USER_PROFILE_RATING';
export const SELECT_USER_PROFILE_AVATAR = 'user::SELECT_USER_PROFILE_AVATAR';
export const SET_CURRENT_PROFILE_AVATAR = 'user::SET_CURRENT_PROFILE_AVATAR';

export const SET_OTT_LAST_CONNECTION = 'user::SET_OTT_LAST_CONNECTION';
export const SET_LAST_PROVISION_DATE = 'user::SET_LAST_PROVISION_DATE';

export const SET_SUSPENSION_TYPE = 'user::SET_SUSPENSION_TYPE';

export const RESET_CLIENT_ID = 'user::RESET_CLIENT_ID';

export const RESET_CASHED_PINS = 'user::RESET_CASHED_PINS';
export const SET_CASHED_PIN = 'user::SET_CASHED_PIN';

export const SET_LINEUP_CHANGED = 'user::SET_LINEUP_CHANGED';
export const SET_SHOW_LINEUP_MODAL = 'user::SET_SHOW_LINEUP_MODAL';

export const UPDATE_PROFILE_RELATED_DATA = 'user::UPDATE_PROFILE_RELATED_DATA';
export const UPDATE_PROFILE_RELATED_DATA_REQUEST =
    'user::UPDATE_PROFILE_RELATED_DATA_REQUEST';
export const UPDATE_PROFILE_RELATED_DATA_SUCCESS =
    'user::UPDATE_PROFILE_RELATED_DATA_SUCCESS';
export const UPDATE_PROFILE_RELATED_DATA_FAILURE =
    'user::UPDATE_PROFILE_RELATED_DATA_FAILURE';

export const SET_CONNECTION_TYPE = 'user::SET_CONNECTION_TYPE';

export const ACCOUNT_INFO_SUCCESS = 'user::ACCOUNT_INFO_SUCCESS';
